<template>
  <div
    class="home"
    v-scroll="handleScroll"
  >
    <div class="kapu left">
      <img
        class="kbanner left"
        src="../assets/img/banner/mercedes-banner-left.jpg"
        alt="Mercedes Benz"
      >
      <div
        class="magsidebar"
        v-bind:class="{ 'show': scrolled }"
      >
        <a
          href="https://forbes.hu"
          target="_blank"
          title="Tovább forbes.hu-ra"
        >
          <img
            src="../assets/img/forbes-cover-sidebar.jpg"
            alt="Forbes"
          >
          Részletek a magazinban!
        </a>
      </div>
    </div>
    <div class="kapu mid"><a
        href="http://bit.ly/2UZ5r3N"
        target="_blank"
        title="Mercedes Benz - Előzze meg a jövőt."
      ><img
          class="kbanner middle"
          src="../assets/img/banner/mercedes-banner-top.jpg"
          alt="Mercedes Benz"
        ></a></div>
    <div class="kapu right">
      <img
        class="kbanner right"
        src="../assets/img/banner/mercedes-banner-right.jpg"
        alt="Mercedes Benz"
      >
      <div
        class="magsidebar"
        v-bind:class="{ 'show': scrolled }"
      >
        <a
          href="https://forbes.hu"
          target="_blank"
          title="Tovább forbes.hu-ra"
        >
          <img
            src="../assets/img/forbes-cover-sidebar.jpg"
            alt="Forbes"
          >
          Részletek a magazinban!
        </a>
      </div>
    </div>
    <div class="container">
      <HeadComponent />
      <LeadComponent />
      <ContentComponent />
      <FooterComponent />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HeadComponent from '@/components/Header.vue';
import LeadComponent from '@/components/Lead.vue';
import ContentComponent from '@/components/Content.vue';
import FooterComponent from '@/components/Footer.vue';

export default {
  name: 'home',
  components: {
    HeadComponent,
    LeadComponent,
    ContentComponent,
    FooterComponent,
  },
  data() {
    return {
      scrolled: false,
    };
  },
  methods: {
    handleScroll() {
      const headPos = document.querySelector('.kbanner.left').offsetTop + document.querySelector('.kbanner.left').offsetHeight;
      const sideMagWidth = document.querySelector('.kapu.left').offsetWidth;
      if (window.scrollY > headPos) {
        this.scrolled = true;
        const magsidebar = document.querySelectorAll('.magsidebar');
        magsidebar.forEach((el) => {
          // eslint-disable-next-line
          el.style.width = `${sideMagWidth}px`;
          const magIMG = window.innerHeight / 2 - document.querySelector('.right .magsidebar img').offsetHeight / 2;
          // eslint-disable-next-line
          el.style.top = `${magIMG}px`;
        });
      } else {
        this.scrolled = false;
      }
    },
  },
};
</script>

<style scoped lang="css">
.home {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: auto auto;
}
.container {
  display: block;
  margin: 0 auto;
  max-width: 1024px;
  grid-column: 2/3;
  grid-row: 2/3;
}
.kapu {
  position: relative;
}
.kapu.left {
  grid-column: 1/2;
  grid-row: 2/3;
  line-height: 0;
}
.kapu.mid {
  grid-column: 1/4;
  grid-row: 1/2;
  line-height: 0;
}
.kapu.right {
  grid-column: 3/4;
  grid-row: 2/3;
  line-height: 0;
}
.magsidebar {
  position: fixed;
  background-color: #fff;
  text-align: center;
  opacity: 0;
  pointer-events: none;
  transition: all linear 0.5s;
}
.magsidebar.show {
  opacity: 1;
  pointer-events: initial;
}
.magsidebar a {
  color: #000;
  text-decoration: none;
  line-height: initial;
  font-weight: 700;
  font-size: 18px;
}
.magsidebar img {
  margin: 0 auto;
  max-width: 215px;
  display: block;
}
.left .magsidebar {
  left: 0px;
}
.right .magsidebar {
  right: 0px;
}
.kapu img {
  width: 100%;
}
@media screen and (max-width: 1279px) {
  .magsidebar a {
    font-size: 12px;
  }
}
@media screen and (max-width: 1189px) {
  .kapu {
    display: none;
  }
  .home {
    grid-template-columns: auto;
    grid-template-rows: auto;
  }
  .container {
    grid-column: 1/2;
    grid-row: 1/2;
  }
  .magsidebar.show {
    display: none;
  }
}
</style>
<style lang="css">
.head,
.footer {
  background-color: #26292f;
  display: grid;
}
</style>
